import MonegraphERC721JSON from './MonegraphERC721V3.json';

const contract = require('@truffle/contract');

export default contract({
  abi: MonegraphERC721JSON.abi,
});
